/* =========================================
   COOKIE CONFIG
========================================= */

const isProduction = process.env.NODE_ENV === "production";

/* =========================================
   SET COOKIE
========================================= */
const setCookie = (name, value, days = 7) => {
  const expires = new Date(
    Date.now() + days * 24 * 60 * 60 * 1000
  ).toUTCString();

  let cookie =
    `${name}=${encodeURIComponent(value)}; ` +
    `expires=${expires}; ` +
    `path=/; ` +
    `SameSite=Lax; `;

  if (isProduction) {
    cookie += "Secure; ";
  }

  document.cookie = cookie;
};

/* =========================================
   GET COOKIE
========================================= */
const getCookie = (name) => {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, ...value] = cookie.split("=");

    if (key === name) {
      return decodeURIComponent(value.join("="));
    }
  }

  return null;
};

/* =========================================
   DELETE COOKIE
========================================= */
const deleteCookie = (name) => {
  let cookie =
    `${name}=; ` +
    `expires=Thu, 01 Jan 1970 00:00:00 UTC; ` +
    `Max-Age=0; ` +
    `path=/; ` +
    `SameSite=Lax; `;

  if (isProduction) {
    cookie += "Secure; ";
  }

  document.cookie = cookie;
};

/* =========================================
   ACCESS TOKEN
========================================= */

export const saveAccessToken = (token) => {
  if (!token) return;
  setCookie("accessToken", token, 1);
};

export const getAccessToken = () => {
  return getCookie("accessToken");
};

/* =========================================
   REFRESH TOKEN
========================================= */

export const saveRefreshToken = (token) => {
  if (!token) return;
  setCookie("refreshToken", token, 7);
};

export const getRefreshToken = () => {
  return getCookie("refreshToken");
};

/* =========================================
   USER DATA
========================================= */

export const saveUserId = (userId) => {
  setCookie("currentUserId", userId, 7);
};

export const getCurrentUserId = () => {
  return getCookie("currentUserId");
};

export const setUserFullName = (userFullName) => {
  setCookie("currentUserName", userFullName, 7);
};

export const getUserFullName = () => {
  return getCookie("currentUserName");
};

export const setUserProfile = (userProfile) => {
  setCookie("currentUserProfile", userProfile || "", 7);
};

export const getUserProfile = () => {
  return getCookie("currentUserProfile");
};

export const setUserRole = (userRole) => {
  setCookie("userRole", userRole, 7);
};

export const getCurrentUserRole = () => {
  return getCookie("userRole");
};

export const setkycStatus = (kycStatus) => {
  setCookie("kycStatus", kycStatus, 7);
};

export const getkycStatus = () => {
  return getCookie("kycStatus");
};

export const setAdhaarVerified = (adhaarVerified) => {
  setCookie("adhaarVerified", adhaarVerified, 7);
};

export const getAdhaarVerified = () => {
  console.log("CHECKING INFO: ", getCookie("adhaarVerified"));
  
  return getCookie("adhaarVerified");

};

/** Backend returns `accessToken`; support legacy `token` field. */
export const saveAuthSession = (data) => {
  const accessToken = data?.accessToken || data?.token;
  const refreshToken = data?.refreshToken;
  if (accessToken) {
    saveAccessToken(accessToken);
  }
  if (refreshToken) {
    saveRefreshToken(refreshToken);
  }

  const user = data?.user;
  const userId = user?.userId || data?.userId;
  if (userId) {
    saveUserId(userId);
  }
  if (user?.role) {
    setUserRole(user.role);
  }
  if (user?.fullName) {
    setUserFullName(user.fullName);
  }
  if (user?.profilePic) {
    setUserProfile(user.profilePic);
  }
  if (user?.kycStatus) {
    setkycStatus(user.kycStatus);
  }
  if (user?.adhaarVerified) {
    setAdhaarVerified(user.adhaarVerified);
  }

  return accessToken;
};

/* =========================================
   AUTH CHECK
========================================= */

export const isLoggedIn = () => {
  return !!(
    getAccessToken() &&
    getRefreshToken() &&
    getCurrentUserId()
  );
};

/* =========================================
   LOGOUT
========================================= */

export const logout = () => {
  const cookies = [
    "accessToken",
    "refreshToken",
    "currentUserId",
    "currentUserName",
    "currentUserProfile",
    "userRole",
    "kycStatus",
    "adhaarVerified",
  ];

  cookies.forEach((cookie) => deleteCookie(cookie));
};


// -------------------------------------------------------------------------------





// /* ==============================
//    Cookie Utility Functions
// ================================= */

// // Set Cookie
// const setCookie = (name, value, days = 7) => {
//   const expires = new Date(Date.now() + days * 86400000).toUTCString();
//   document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict`;
// };

// // Get Cookie
// const getCookie = (name) => {
//   const cookies = document.cookie.split("; ");
//   const found = cookies.find((row) => row.startsWith(name + "="));
//   return found ? decodeURIComponent(found.split("=")[1]) : null;
// };

// // Delete Cookie
// const deleteCookie = (name) => {
//   document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
// };

// /* ==============================
//    AUTH TOKENS (UPDATED)
// ================================= */

// // Save Access Token (short expiry)
// export const saveAccessToken = (token) => {
//   setCookie("accessToken", token, 1); // 1 day
// };

// // Get Access Token
// export const getAccessToken = () => {
//   return getCookie("accessToken");
// };

// // Save Refresh Token (long expiry)
// export const saveRefreshToken = (token) => {
//   setCookie("refreshToken", token, 7); // 7 days
// };

// // Get Refresh Token
// export const getRefreshToken = () => {
//   return getCookie("refreshToken");
// };

// /* ==============================
//    USER DATA
// ================================= */

// // User ID
// export const saveUserId = (userId) => {
//   setCookie("currentUserId", userId, 7);
// };

// export const getCurrentUserId = () => {
//   return getCookie("currentUserId");
// };

// // Full Name
// export const setUserFullName = (userFullName) => {
//   setCookie("currentUserName", userFullName, 7);
// };

// export const getUserFullName = () => {
//   return getCookie("currentUserName");
// };

// // Profile
// export const setUserProfile = (userProfile) => {
//   setCookie("currentUserProfile", userProfile || "", 7);
// };

// export const getUserProfile = () => {
//   return getCookie("currentUserProfile");
// };

// // Role
// export const setUserRole = (userRole) => {
//   setCookie("userRole", userRole, 7);
// };

// export const getCurrentUserRole = () => {
//   return getCookie("userRole");
// };

// // KYC Status
// export const setkycStatus = (kycStatus) => {
//   setCookie("kycStatus", kycStatus, 7);
// };

// export const getkycStatus = () => {
//   return getCookie("kycStatus");
// };

// // Aadhaar Verified
// export const setAdhaarVerified = (adhaarVerified) => {
//   setCookie("adhaarVerified", adhaarVerified, 7);
// };

// export const getAdhaarVerified = () => {
//   return getCookie("adhaarVerified");
// };

// /* ==============================
//    AUTH STATE CHECK
// ================================= */

// export const isLoggedIn = () => {
//   const accessToken = getAccessToken();
//   const refreshToken = getRefreshToken();
//   const userId = getCurrentUserId();

//   return !!accessToken && !!refreshToken && !!userId;
// };

// /* ==============================
//    LOGOUT
// ================================= */

// export const logout = () => {
//   deleteCookie("accessToken");
//   deleteCookie("refreshToken");
//   deleteCookie("currentUserId");
//   deleteCookie("currentUserName");
//   deleteCookie("currentUserProfile");
//   deleteCookie("userRole");
//   deleteCookie("kycStatus");
//   deleteCookie("adhaarVerified");
// };

// --------------------------------------------------------------------------------


// /* ==============================
//    Cookie Utility Functions
// ================================= */

// // Set Cookie
// const setCookie = (name, value, days = 7) => {
//   const expires = new Date(Date.now() + days * 86400000).toUTCString();
//   document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict`;
// };

// // Get Cookie
// const getCookie = (name) => {
//   const cookies = document.cookie.split("; ");
//   const found = cookies.find((row) => row.startsWith(name + "="));
//   return found ? decodeURIComponent(found.split("=")[1]) : null;
// };

// // Delete Cookie
// const deleteCookie = (name) => {
//   document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
// };

// /* ==============================
//    Auth Token
// ================================= */

// // Save auth token in cookies
// export const saveToken = (token) => {
//   setCookie("token", token, 7);
// };

// // Retrieve auth token
// export const getToken = () => {
//   return getCookie("token");
// };

// /* ==============================
//    User ID
// ================================= */

// export const saveUserId = (userId) => {
//   setCookie("currentUserId", userId, 7);
// };

// export const getCurrentUserId = () => {
//   return getCookie("currentUserId");
// };

// /* ==============================
//    User Full Name
// ================================= */

// export const setUserFullName = (userFullName) => {
//   setCookie("currentUserName", userFullName, 7);
// };

// export const getUserFullName = () => {
//   return getCookie("currentUserName");
// };

// /* ==============================
//    User Profile
// ================================= */

// export const setUserProfile = (userProfile) => {
//   setCookie("currentUserProfile", userProfile, 7);
// };

// export const getUserProfile = () => {
//   return getCookie("currentUserProfile");
// };

// /* ==============================
//    User Role
// ================================= */

// export const setUserRole = (userRole) => {
//   setCookie("userRole", userRole, 7);
// };

// export const getCurrentUserRole = () => {
//   return getCookie("userRole");
// };

// /* ==============================
//    KYC Status
// ================================= */

// export const setkycStatus = (kycStatus) => {
//   setCookie("kycStatus", kycStatus, 7);
// };

// export const getkycStatus = () => {
//   return getCookie("kycStatus");
// };

// /* ==============================
//    Aadhaar Verified Status
// ================================= */

// export const setAdhaarVerified = (adhaarVerified) => {
//   setCookie("adhaarVerified", adhaarVerified, 7);
// };

// export const getAdhaarVerified = () => {
//   return getCookie("adhaarVerified");
// };

// /* ==============================
//    Check Login Status
// ================================= */

// export const isLoggedIn = () => {
//   const token = getToken();
//   const userId = getCurrentUserId();
//   return !!token && !!userId;
// };

// /* ==============================
//    Logout
// ================================= */

// export const logout = () => {
//   // if (confirmLogout) {
//     deleteCookie("token");
//     deleteCookie("currentUserId");
//     deleteCookie("currentUserName");
//     deleteCookie("currentUserProfile");
//     deleteCookie("userRole");
//     deleteCookie("kycStatus");
//     deleteCookie("adhaarVerified");
//   // }
// };
